import "./footer.css"
import ScrollToTop from "react-scroll-to-top";
function Footer(){
    return(
        <>
        <h2 className="footer-name">©2023 All rights reserved / Privacy Policy / Omkar Jadhav</h2>
        <ScrollToTop smooth />
        </>
    )
}
export default Footer;